<div class="backdrop">
  <div class="pic"></div>
  <div class="form">
    <app-forgot-password-form></app-forgot-password-form>
  </div>
</div>
